import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\UnarchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/UnarchiveDirectoryRecordsController.php
* @route '/api/contact-directory/unarchive'
*/
const UnarchiveDirectoryRecordsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnarchiveDirectoryRecordsController.url(options),
    method: 'post',
})

UnarchiveDirectoryRecordsController.definition = {
    methods: ["post"],
    url: '/api/contact-directory/unarchive',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactDirectory\UnarchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/UnarchiveDirectoryRecordsController.php
* @route '/api/contact-directory/unarchive'
*/
UnarchiveDirectoryRecordsController.url = (options?: RouteQueryOptions) => {
    return UnarchiveDirectoryRecordsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\UnarchiveDirectoryRecordsController::__invoke
* @see app/Http/Controllers/ContactDirectory/UnarchiveDirectoryRecordsController.php
* @route '/api/contact-directory/unarchive'
*/
UnarchiveDirectoryRecordsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnarchiveDirectoryRecordsController.url(options),
    method: 'post',
})

export default UnarchiveDirectoryRecordsController